module.exports = __webpack_public_path__ + "static/media/tony-o-donovan.81050693.png";